import { useState, useEffect } from 'react'
import './header.css'
import logo from '../assets/factura247.svg'

const NAV_LINKS = [
    { href: '#caracteristicas', label: 'Características' },
    { href: '#ventajas', label: 'Ventajas' },
    { href: '#descargar', label: 'Descargar' },
]

export default function Header() {
    const [scrolled, setScrolled] = useState(false)
    const [menuOpen, setMenuOpen] = useState(false)

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24)
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return (
        <header className={`app-header${scrolled ? ' app-header--scrolled' : ''}`}>
            <h1 className="sr-only">Factur 24/7 - App de facturación electrónica gratuita</h1>
            <div className="header-inner">
                {/* Logo + brand */}
                <a href="/" className="header-brand" aria-label="Factur 24/7 — inicio">
                    <img src={logo} alt="" className="header-logo" width="33" height="36" loading="eager" aria-hidden="true" />
                    <span className="header-brand-name">Factur <span className="header-brand-accent">24/7</span></span>
                </a>

                {/* Desktop nav */}
                <nav className="header-nav" aria-label="Navegación principal">
                    {NAV_LINKS.map((link) => (
                        <a key={link.href} href={link.href} className="header-nav-link">
                            {link.label}
                        </a>
                    ))}
                </nav>

                {/* CTA */}
                <a
                    className="header-cta"
                    href="https://factur247.com/app/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    App Web
                </a>

                {/* Hamburger */}
                <button
                    className={`header-hamburger${menuOpen ? ' header-hamburger--open' : ''}`}
                    aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen((v) => !v)}
                >
                    <span /><span /><span />
                </button>
            </div>

            {/* Mobile menu */}
            {menuOpen && (
                <nav className="header-mobile-menu" aria-label="Menú móvil">
                    {NAV_LINKS.map((link) => (
                        <a
                            key={link.href}
                            href={link.href}
                            className="header-mobile-link"
                            onClick={() => setMenuOpen(false)}
                        >
                            {link.label}
                        </a>
                    ))}
                    <a
                        className="header-cta header-cta--mobile"
                        href="https://factur247.com/app/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setMenuOpen(false)}
                    >
                        App Web
                    </a>
                </nav>
            )}
        </header>
    )
}
